<page-heading [title]="'report.apiLoggings.pageTitle' | translate" [hasBreadcrumb]="true" />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2 align-items-center">
            <div class="col-xs-12 col-lg-3 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'report.apiLoggings.searchPlaceholder' | translate"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>

            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.apiLoggings.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'report.apiLoggings.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    [placeholder]="'report.apiLoggings.selectPlaceholder' | translate"
                    (selectionChange)="onPeriodChange($event)"
                  >
                    <mat-option value="1">{{ 'report.apiLoggings.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.apiLoggings.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.apiLoggings.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.apiLoggings.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.apiLoggings.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div class="col-xs-12 col-md-4 col-lg-2 btn-group trend-button">
              <button
                [matMenuTriggerFor]="filterChannel"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                <button mat-menu-item (click)="searchByChannel(null)">
                  {{ 'report.apiLoggings.all' | translate }}
                </button>
                @for (channel of listChannel; track $index) {
                  <button mat-menu-item (click)="searchByChannel(channel)">
                    {{ channel.name }}
                  </button>
                }
              </mat-menu>
            </div>

            <div class="col-xs-12 col-md-4 col-lg-2 btn-group trend-button">
              <button
                [matMenuTriggerFor]="filterMethod"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelMethod }}</span>
              </button>
              <mat-menu #filterMethod="matMenu">
                <button mat-menu-item (click)="searchByMethod(null)">
                  {{ 'report.apiLoggings.all' | translate }}
                </button>
                @for (method of listMethod; track $index) {
                  <button mat-menu-item (click)="searchByMethod(method)">
                    {{ method }}
                  </button>
                }
              </mat-menu>
            </div>

            <div class="col-xs-12 col-md-4 col-lg-2 btn-group trend-button">
              <button
                [matMenuTriggerFor]="filterStatus"
                type="button"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelStatusCode }}</span>
              </button>
              <mat-menu #filterStatus="matMenu">
                <button mat-menu-item (click)="searchByStatusCode(null)">
                  {{ 'report.apiLoggings.all' | translate }}
                </button>
                @for (status of listStatusCode; track $index) {
                  <button mat-menu-item (click)="searchByStatusCode(status)">
                    {{ status.label }}
                  </button>
                }
              </mat-menu>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body">
    @if (loadingContent) {
      <content-loading-list />
    }

    @if (!loadingContent && pager.total === 0) {
      <empty-records-component
        [message]="'report.apiLoggings.emptyMessage' | translate"
        [subMessage]="'report.apiLoggings.emptySubMessage' | translate"
        [icon]="'ri-code-line'"
      />
    }

    @if (!loadingContent && pager?.total > 0) {
      <div class="table-responsive">
        <table class="table table-hover table-centered mb-0">
          <thead>
            <tr>
              <th class="text-primary-emphasis">{{ 'report.apiLoggings.columnUrlDate' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.apiLoggings.columnChannel' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.apiLoggings.columnMethod' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.apiLoggings.columnStatus' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.apiLoggings.columnRequestResponse' | translate }}</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pager?.list; track item) {
              <tr>
                <td>
                  <span
                    class="d-block text-truncate"
                    style="max-width: 280px"
                    [matTooltip]="item.url"
                  >
                    {{ item.url }}
                  </span>
                  <small class="text-muted">
                    {{
                      item.createdAt
                        | timezoneDate
                          : "DD/MM/YYYY HH:mm"
                          : getTimezoneCompanyCurrentUser()
                    }}
                  </small>
                </td>
                <td>
                  @if (item?.channel) {
                    <span>{{ item?.channel?.["name"] }}</span>
                  } @else {
                    <span class="text-muted">-</span>
                  }
                </td>
                <td>
                  <span class="badge bg-secondary font-13">{{
                    item?.method
                  }}</span>
                </td>
                <td>
                  @if (item?.statusCode >= 200 && item?.statusCode < 300) {
                    <span class="badge bg-success font-13">{{
                      item?.statusCode
                    }}</span>
                  } @else if (
                    item?.statusCode >= 400 && item?.statusCode < 500
                  ) {
                    <span class="badge bg-warning font-13">{{
                      item?.statusCode
                    }}</span>
                  } @else if (item?.statusCode >= 500) {
                    <span class="badge bg-danger font-13">{{
                      item?.statusCode
                    }}</span>
                  } @else {
                    <span class="badge bg-primary font-13">{{
                      item?.statusCode
                    }}</span>
                  }
                </td>
                <td>
                  <div class="d-flex gap-1">
                    @if (item?.requestBody) {
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm rounded-pill"
                        (click)="viewBody($safeNavigationMigration(item?.requestBody), t('report.apiLoggings.requestBodyTitle'))"
                      >
                        {{ 'report.apiLoggings.requestButton' | translate }}
                      </button>
                    }
                    @if (item?.responseBody) {
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm rounded-pill"
                        (click)="viewBody($safeNavigationMigration(item?.responseBody), t('report.apiLoggings.responseBodyTitle'))"
                      >
                        {{ 'report.apiLoggings.responseButton' | translate }}
                      </button>
                    }
                  </div>
                </td>
                <td align="right">
                  <button
                    class="btn btn-secondary btn-sm"
                    (click)="viewItem(item)"
                  >
                    <i class="mdi mdi-magnify font-18"></i>
                    {{ 'report.apiLoggings.viewButton' | translate }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)" />
      }
    }
  </div>
</div>
